export default {
    zariadenia: {
      ustredne: {label: "Ústredne"},
      hlasice: {label: "Hlásiče"},
      signalizacnePrvky: {label: "Signalizačné prvky"},
      ineZariadenia: {label: "Iné zariadenia"},
    },
    osoby: {
      osobyZodpovedne: {label: "Osoby poverené ako „Osoby zodpovedné“ za prevádzku EPS + HSP"},
      osobyKontrolne: {label: "Osoby poverené vykonávaním predpísaných kontrol a údržby EPS + HSP"},
      osobyObsluha: {label: "Osoby poverené obsluhou zariadenia EPS + HSP"}
    }
  }


// WEBPACK FOOTER //
// ./src/prevadzkova-kniha/PrevadzkovaKnihaSections.js